import React, { useEffect, useState } from 'react';
import { fetchCarouselDoodles } from './carouselApi';
import './Carousel.css';

const DECODE_TIMEOUT_MS = 8000;
const SKELETON_TILE_COUNT = 10;

function shuffle(arr) {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function Carousel() {
  const [items, setItems] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let timeoutHandle = null;

    (async () => {
      try {
        const data = await fetchCarouselDoodles();
        if (cancelled) return;
        const fetched = Array.isArray(data?.items) ? data.items : [];
        if (fetched.length === 0) {
          setReady(true);
          return;
        }

        const shuffled = shuffle(fetched);
        const decodePromises = shuffled.map((item) => {
          const img = new Image();
          img.src = item.imageUrl;
          return img.decode().catch(() => {});
        });

        await Promise.race([
          Promise.allSettled(decodePromises),
          new Promise((resolve) => {
            timeoutHandle = setTimeout(resolve, DECODE_TIMEOUT_MS);
          }),
        ]);

        if (cancelled) return;
        setItems(shuffled);
        setReady(true);
      } catch {
        if (!cancelled) setReady(true);
      }
    })();

    return () => {
      cancelled = true;
      if (timeoutHandle) clearTimeout(timeoutHandle);
    };
  }, []);

  if (!ready) {
    return (
      <section className="carousel" aria-busy="true">
        <div className="carousel-track">
          <div className="carousel-skeleton">
            {Array.from({ length: SKELETON_TILE_COUNT }).map((_, i) => (
              <div key={i} className="carousel-skeleton-tile" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (items.length === 0) return null;

  const doubled = [...items, ...items];

  return (
    <section className="carousel">
      <div className="carousel-track">
        <div className="carousel-strip">
          {doubled.map((item, i) => (
            <img
              key={i}
              src={item.imageUrl}
              alt={item.drawingSubject || 'Community drawing'}
              title={`${item.drawingSubject || 'Untitled'} — ${item.signature || 'Anonymous'}`}
              className="carousel-tile"
              loading="eager"
              decoding="async"
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Carousel;
